module.exports = __webpack_public_path__ + "6babca8e69af0a13d3107842e91fc788.fbx";